import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { NewShowtimes, Showtimes } from '../movies';
import {
  OfferDetailsResponse,
  Offers,
  UnipalOfferDataModel,
  UnipalVerifyResponseModel,
} from './models';
import { axiosInstance, createMutation, createQuery } from '@/logic/libs';

const url = 'offers';

export const getOffersList = (
  params: {
    cityId: number;
  },
  config: AxiosRequestConfig = {}
): Promise<Offers> => {
  return axiosInstance
    .get(`${url}`, { params, ...config })
    .then((res: AxiosResponse<Offers>) => {
      return res?.data;
    });
};

export const useGetOffersList = createQuery<
  Offers,
  unknown,
  null,
  {
    cityId: number;
    filmId?: number;
    date?: string;
  }
>({
  url: `${url}`,
  method: 'get',
});

export const useGetOfferShowtimes = createQuery<
  NewShowtimes,
  unknown,
  'offerId',
  {
    cityId: number;
  }
>({
  url: `${url}/:offerId/showtimes`,
  method: 'get',
});

// export const useGetOfferFilms = createInfiniteQuery<
//   FilmsPaginated,
//   unknown,
//   'offerId',
//   {
//     cityId: number;
//     date: string;
//   }
// >({
//   url: `${url}/:offerId/films`,
//   method: 'get',
// });

export const getOfferDetails = (
  slug: string,
  params: {
    cityId: number;
  },
  config: AxiosRequestConfig = {}
): Promise<OfferDetailsResponse> => {
  return axiosInstance
    .get(`${url}/unique-name/${slug}`, { params, ...config })
    .then((res: AxiosResponse<OfferDetailsResponse>) => {
      return res?.data;
    });
};

export type GetOfferDetailsRequest = {
  offerId: string;
  // offerId: number;
  cityId: number;
};

export type GetOfferShowTimesRequest = GetOfferDetailsRequest & {
  config?: AxiosRequestConfig;
};

export const getOfferShowTimes = ({
  offerId,
  cityId,
  config,
}: GetOfferShowTimesRequest): Promise<Showtimes> => {
  return axiosInstance
    .get(`${url}/:offerId/showtimes`, {
      params: { cityId, ...config.params },
      query: { offerId, ...config.query },
      ...config,
    })
    .then((res: AxiosResponse<Showtimes>) => {
      return res?.data;
    });
};

export type GetOfferFilmsRequest = GetOfferShowTimesRequest & {
  date: string;
};

// export const getOfferFilmsByShowtime = ({
//   offerId,
//   cityId,
//   date,
//   config,
// }: GetOfferFilmsRequest): Promise<FilmsPaginated> => {
//   return axiosInstance
//     .get(`${url}/:offerId/films`, {
//       ...config,
//       params: { cityId, date, ...config?.params },
//       query: { offerId, ...config?.query },
//     })
//     .then((res: AxiosResponse<FilmsPaginated>) => {
//       return res?.data;
//     });
// };

export const useGetOfferDetails = createQuery<
  OfferDetailsResponse,
  unknown,
  string,
  {
    cityId: number;
  }
>({
  url: `${url}/:offerId`,
  method: 'get',
});

export const useGetOfferDetailsBySlug = createQuery<
  OfferDetailsResponse,
  unknown,
  string,
  {
    cityId: number;
  }
>({
  url: `${url}/unique-name/:slug`,
  method: 'get',
});

export const useVerifyOffer = createMutation<
  UnipalVerifyResponseModel,
  unknown,
  'offerId',
  | {
      bin?: string;
      last4?: string;
      cityId: number;
      sessionId?: number;
      expiryMonth?: string;
      expiryYear?: string;
    }
  | UnipalOfferDataModel
>({
  method: 'get',
  url: `${url}/:offerId/verify`,
});

export const useCheckMovieOffers = createQuery<{ hasOffer: boolean }>({
  method: 'get',
  url: `${url}/check-film`,
});
